export default __webpack_public_path__ + "static/media/lake-canoing.5db422f8.jpg";